'use strict';

var curve = exports;

curve.base = require('./base');
curve.short = require('./short');
curve.mont = require('./mont');
curve.edwards = require('./edwards');



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/Source/aws-lex-web-ui/node_modules/elliptic/lib/elliptic/curve/index.js
// module id = 97
// module chunks = 0